// lazy-sections.js — Phase 5 (jm-2.0.0)
// IntersectionObserver for [data-lazy-section] elements.
// Defers section JS initialization until near-visible (200px margin).
// Skips lazy loading entirely in Theme Editor (Shopify.designMode).

(function () {
  // In Design Mode, merchants need to see sections immediately
  if (typeof Shopify !== 'undefined' && Shopify.designMode) return;

  if (!('IntersectionObserver' in window)) {
    // Fallback: initialize all lazy sections after 3s
    setTimeout(function () { initAll(document); }, 3000);
    return;
  }

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        initSection(entry.target);
        observer.unobserve(entry.target);
      }
    });
  }, {
    rootMargin: '200px'
  });

  function initSection(el) {
    if (el.hasAttribute('data-initialized')) return;
    el.setAttribute('data-initialized', '');

    // Dispatch event so section-specific JS can react
    el.dispatchEvent(new CustomEvent('theme:section-visible', { bubbles: true }));

    // If the section has a data-module, trigger the auto-loader for it
    if (window.theme && window.theme.scanModules) {
      window.theme.scanModules(el);
    }
  }

  function initAll(root) {
    var sections = (root || document).querySelectorAll('[data-lazy-section]');
    for (var i = 0; i < sections.length; i++) {
      initSection(sections[i]);
    }
  }

  function observe(root) {
    var sections = (root || document).querySelectorAll('[data-lazy-section]:not([data-initialized])');
    for (var i = 0; i < sections.length; i++) {
      observer.observe(sections[i]);
    }
  }

  // Initial observation
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { observe(); });
  } else {
    observe();
  }

  // Re-observe after dynamic DOM updates
  document.addEventListener('theme:dom-updated', function (e) {
    if (e.detail && e.detail.container) {
      observe(e.detail.container);
    }
  });

  // Expose for manual use
  window.theme = window.theme || {};
  window.theme.observeLazySections = observe;
})();
